module.exports = require('./helpers/bundle-url').getBundleURL('luNwF') + "logo.2bd7c023.svg";